// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__RMCl4","buttons":"RemoveExpirationActionButtons_buttons__FY4A6"};